// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { PostVocAutoMateTasksMonitorBody, BaseResponseVoid } from '../../types';

/**
 * saveMonitorConf
 *
 * @export
 * @tags voc自动化配置
 * @link [POST] /vocAutoMateTasks/monitor
 */
export function postVocAutoMateTasksMonitor(
    data: PostVocAutoMateTasksMonitorBody
): Promise<BaseResponseVoid>;
export function postVocAutoMateTasksMonitor(
    data: PostVocAutoMateTasksMonitorBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function postVocAutoMateTasksMonitor(
    data: PostVocAutoMateTasksMonitorBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PostVocAutoMateTasksMonitorBody, never, never>('/vocAutoMateTasks/monitor', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postVocAutoMateTasksMonitor',
    });
}

export const meta = [
    { tags: ['voc自动化配置'], path: '/vocAutoMateTasks/monitor', method: 'post' },
];
